import React from 'react';
import { useQuery } from 'react-query';

import { Breadcrumb } from 'antd';

import { getAIFeedbacks } from 'apis/FeedbackAPI';
import Header from 'common/Header';
import RecommendationCompanyBreadcrumb from 'components/AiCompetitiveIntelligence/RecommendationCompanyBreadcrumb';
import useRecommendationsContext from 'components/AiCompetitiveIntelligence/RecommendationsContext';
import { AI_FEEDBACK_FEATURE_TYPES } from 'components/Feedback/constants';
import Feedback from 'components/Feedback/Feedback';

const AIOverviewHeader = () => {
  const { company, companyOptions } = useRecommendationsContext();
  const hasMultipleCompanies = companyOptions.length > 1;

  const { data: feedback } = useQuery({
    queryKey: ['ai-feedbacks', AI_FEEDBACK_FEATURE_TYPES.COMPANY_AI_OVERVIEW, company?.id],
    queryFn: () => getAIFeedbacks({ feature_type: AI_FEEDBACK_FEATURE_TYPES.COMPANY_AI_OVERVIEW }),
    select: (feedbacks) => feedbacks?.[0] ?? null,
    enabled: Boolean(company?.id),
    refetchOnWindowFocus: false,
  });

  return (
    <Header
      title={company?.name || ''}
      breadcrumbs={
        hasMultipleCompanies ? <RecommendationCompanyBreadcrumb /> : <Breadcrumb items={[{ title: 'Company' }]} />
      }
    >
      <Feedback
        subtitle={company?.name || ''}
        featureType={AI_FEEDBACK_FEATURE_TYPES.COMPANY_AI_OVERVIEW}
        sourceUrl={window.location.href}
        existingFeedback={feedback}
      />
    </Header>
  );
};

export default AIOverviewHeader;
